export enum AllergyTypeEnum {
  Current = 1,
  Historical = 2
}

export const AllergyTypeOptions = [
{ id: 1, label: 'Current' },
{ id: 2, label: 'Historical' }
];
